export default "__VITE_ASSET__Dsu5wsgp__"